<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <LoadCard v-if="load"></LoadCard>

        <DashboardCard v-else>
            <blockquote class="card-blockquote">
                <b-icon icon="mailbox" class="icone-statements"></b-icon>
                <p>Denuncias subidas</p>

                <footer>
                    <h2>{{ getCount }}</h2>
                </footer>

            </blockquote>
        </DashboardCard>
    </div>
</template>
<script>
//signal R
import { hub } from '@/plugins/signalR/index.js';
import { ReceiveHubs, Hubs as namesHub } from '@/plugins/enums/index.js';

//alerta, carga, data
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import LoadCard from '@/components/shared/Load-card.vue'
import DashboardCard from '@/components/shared/Dashboard-card.vue'

//mixin
import { dashboardGraph } from '@/plugins/mixin/index.js'

export default {
    name: 'DenunciationCountGraph',

    mixins: [dashboardGraph],

    data() {
        return {
            count: 0,
            load: true,

            connection: null
        }
    },

    components: {
        AlertDismiss,
        LoadCard,
        DashboardCard
    },

    computed: {
        getCount() {
            return this.count;
        }
    },

    async created() {
        //signal R on - back to front
        this.connection = hub.getInstance(namesHub.denunciationHub)
        await this.connection.start();

        this.countDenunciationsSignalROn(this.connection);
    },

    beforeDestroy() {
        this.connection.off(ReceiveHubs.countDenunciations);
    },

    methods: {
        countDenunciationsSignalROn(connection) {
            connection.on(ReceiveHubs.countDenunciations, (count) => {
                try {
                    if (this.getGraph.mixinItUpdates) { this.count = count; }

                } catch (error) {
                    this.$refs.alertDismiss.showAlert("Error en la gráfica que representa las cantidades de las denuncias.");
                }

                this.load = false;
            });
        }
    }

}
</script>
<style scoped>
</style>